import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CheckboxInput from './CheckboxInput';

interface ActiveClearProps {
  control: Control;
  hideReadyClearToTransport: boolean;
  disabledReadyClearToTransport?: boolean;
  disableClearToTransport?: boolean;
  hideClearToTransport: boolean;
  disabledMessage?: string;
}

export default function ActiveClear({
  control,
  hideReadyClearToTransport,
  disabledReadyClearToTransport,
  disableClearToTransport,
  hideClearToTransport,
  disabledMessage,
}: ActiveClearProps) {
  const { t } = useTranslation('common');

  return (
    <>
      <CheckboxInput
        label={t('common.active')}
        name="IsActive"
        required={false}
        control={control}
      />
      {!hideReadyClearToTransport && (
        <CheckboxInput
          label={t('common.readyClearToTransport')}
          name="IsReadyClearToTransport"
          disabledMessage={disabledMessage}
          disabled={disabledReadyClearToTransport}
          required={false}
          control={control}
        />
      )}
      {!hideClearToTransport && (
        <CheckboxInput
          label={t('common.clearToTransport')}
          name="IsClearToTransport"
          disabledMessage={disabledMessage}
          required={false}
          control={control}
          disabled={disableClearToTransport}
        />
      )}
    </>
  );
}
